import { render } from "./PickupAddressSidebarCard.vue?vue&type=template&id=95440afa&scoped=true&ts=true"
import script from "./PickupAddressSidebarCard.vue?vue&type=script&lang=ts"
export * from "./PickupAddressSidebarCard.vue?vue&type=script&lang=ts"

import "./PickupAddressSidebarCard.vue?vue&type=style&index=0&id=95440afa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95440afa"]])

export default __exports__